<div>
  <h1 mat-dialog-title>
    <i class="fa fa-warning"></i>
    @if (Errors().length > 0) {
      {{Errors()[0].title}}
    }
    @if (Errors().length == 0) {
      Something unexpected happened!
    }
  </h1>
  <div mat-dialog-content>
    @for (error of Errors(); track error) {
      <div>
        <p style="font-weight: bold; margin-bottom: 5px;">
          {{error.message}}
        </p>
        @if (error.techDetails != null && error.fluentValidationErrors?.length == 0) {
          <pre style="max-height: 300px; white-space: pre-wrap">{{error.techDetails}}</pre>
        }
        @if (error.fluentValidationErrors?.length > 0) {
          <ul>
            @for (message of error.fluentValidationErrors; track message) {
              <li>{{message}}</li>
            }
          </ul>
        }
      </div>
    }
  </div>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="close()">
      <i class="fa fa-close"></i>
      Close
    </button>
  </div>
</div>
